export default __webpack_public_path__ + "static/media/binance-chain-wallet.edfbf24b.svg";